import dayjs from "dayjs"

export default function InsumosPedidoStatus({pedido}: iProps) {
    let background = "#264653"
    if (pedido.id_status.id_status === 2) {
        background = "green"
    }
    if (pedido.id_status.id_status === 3) {
        background = "red"
    }
    
    let data_revisado = ""
    if (pedido.id_status.id_status !== 1 && pedido.data_revisado !== null) {
        data_revisado = `Revisado em ${dayjs(pedido.data_revisado).format("DD/MM/YYYY HH:mm:ss")}`
    }
    return (
        <div className="div-row">
            <p style={{color: "white", backgroundColor: background, position: "relative", top: "0", padding: "5px", width: "max-content", fontWeight: "bold", marginRight: "10px"}}>{pedido.id_status.descricao}</p>
            <p>{data_revisado}</p>
        </div>
    )
}
interface iProps {
    pedido: any
}
